/**
 * Loume — Header-Verhalten
 * ========================
 *
 * Schaltet zwei Klassen auf .header-wrapper:
 *   loume-header--scrolled    ab 100px Scroll
 *   loume-header--menu-open   solange das mobile Menü offen ist
 *
 * Das Aussehen steckt vollständig in loume-header.css. Zusätzlich blendet
 * dieses Skript optionale Sticky-Leisten ein — Elemente mit
 * data-loume-sticky-bar, die ab 100px Scroll erscheinen und wieder
 * verschwinden, sobald das per data-loume-sticky-until="#id" benannte
 * Ziel-Element erreicht ist.
 *
 * Ersetzt das Inline-Script, das im alten Theme Stile direkt auf den
 * Elementen gesetzt hat.
 */
(function () {
  'use strict';

  var SCROLL_THRESHOLD = 100;

  var header = document.querySelector('.header-wrapper');
  if (!header) return;

  // Glas beim Überfahren: Mit der Maus über dem Header — oder bei offenem
  // Produktmenü — zeigt er die milchige Leiste auch ganz oben auf der Seite.
  var ueberHeader = false;
  var pmOffen = false;
  function glasSetzen() {
    header.classList.toggle('loume-header--glas', ueberHeader || pmOffen);
  }
  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    header.addEventListener('mouseenter', function () {
      ueberHeader = true;
      glasSetzen();
    });
    header.addEventListener('mouseleave', function () {
      ueberHeader = false;
      glasSetzen();
    });
  }
  var pmDetailsAlle = document.querySelector('.header__inline-menu .loume-produktmenue details');
  if (pmDetailsAlle) {
    pmDetailsAlle.addEventListener('toggle', function () {
      pmOffen = pmDetailsAlle.open;
      glasSetzen();
    });
  }

  // Produktmenü: auf Geräten mit Maus öffnet es beim Überfahren. Das Feld
  // liegt 10px unter dem Header; die kurze Verzögerung beim Schließen trägt
  // den Mauszeiger über diese Lücke. Ohne Maus bleibt es beim Klick (Dawn).
  var produktmenue = document.querySelector('.header__inline-menu .loume-produktmenue');
  if (produktmenue && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    var pmDetails = produktmenue.querySelector('details');
    var pmSummary = pmDetails && pmDetails.querySelector('summary');
    var pmTimer;
    var pmAusblenden = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 450;
    produktmenue.addEventListener('mouseenter', function () {
      clearTimeout(pmTimer);
      produktmenue.classList.remove('loume-produktmenue--schliesst');
      if (pmDetails && !pmDetails.open) {
        pmDetails.open = true;
        pmSummary.setAttribute('aria-expanded', 'true');
      }
    });
    produktmenue.addEventListener('mouseleave', function () {
      clearTimeout(pmTimer);
      pmTimer = setTimeout(function () {
        if (!pmDetails || !pmDetails.open) return;
        // Erst ausblenden (CSS, 0,45 s), dann zuklappen.
        produktmenue.classList.add('loume-produktmenue--schliesst');
        pmTimer = setTimeout(function () {
          pmDetails.open = false;
          pmSummary.setAttribute('aria-expanded', 'false');
          produktmenue.classList.remove('loume-produktmenue--schliesst');
        }, pmAusblenden);
      }, 200);
    });
  }

  var menuDetails = document.querySelector('#Details-menu-drawer-container');
  var stickyBars = Array.prototype.slice.call(document.querySelectorAll('[data-loume-sticky-bar]'));

  var ticking = false;

  function isMenuOpen() {
    return Boolean(menuDetails && menuDetails.open);
  }

  function updateHeader(scrollY) {
    header.classList.toggle('loume-header--menu-open', isMenuOpen());
    // Die Scroll-Klasse bleibt auch bei offenem Menü: Die Leiste soll sich
    // beim Öffnen „überhaupt nicht ändern“ (Gründer, 27.09.2026).
    header.classList.toggle('loume-header--scrolled', scrollY >= SCROLL_THRESHOLD);
  }

  function updateStickyBars(scrollY) {
    for (var i = 0; i < stickyBars.length; i++) {
      var bar = stickyBars[i];
      var visible = scrollY >= SCROLL_THRESHOLD;

      var untilSelector = bar.getAttribute('data-loume-sticky-until');
      if (visible && untilSelector) {
        var target = document.querySelector(untilSelector);
        if (target) {
          var targetTop = target.getBoundingClientRect().top + scrollY;
          visible = scrollY < targetTop;
        }
      }

      bar.classList.toggle('loume-sticky--visible', visible);
    }
  }

  function update() {
    var scrollY = window.scrollY;
    updateHeader(scrollY);
    updateStickyBars(scrollY);
    ticking = false;
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  if (menuDetails) menuDetails.addEventListener('toggle', update);

  update();
})();
